import { useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';

// this allows open link in new tab to work with react router dom it's a bit of a hack
// https://wonolodev.atlassian.net/browse/DMD-3350
export const useQueryParams = () => {
  const location = useLocation(); // Get the current location object

  // Parse query params and memoize the result so it's only recalculated if location.search changes
  const queryParams = useMemo(() => Object.fromEntries(new URLSearchParams(location.search)), []); // https://stackoverflow.com/a/52539264

  // Effect to remove the query string from the URL after acquiring the params
  useEffect(() => {
    if (location.search) {
      // this is a hack to remove the query string from the URL in an attempt to prevent users from modifying the URL
      window.history.replaceState(null, document.title, location.pathname);
    }
  }, [location.search]);

  return queryParams;
};
